import isObject from 'lodash/isObject';

export namespace XStateUtils {
  export function mergeMeta(meta) {
    return Object.keys(meta).reduce((acc, key) => {
      const value = meta[key];

      // Assuming each meta value is an object
      Object.assign(acc, value);

      return acc;
    }, {});
  }

  // To be used when sending events
  export function shortStringify<T>(obj: T): T {
    const toRet = { ...obj };
    if (process.env.NODE_ENV === 'development' && typeof obj === 'object') {
      (toRet as any).toJSON = () => {
        const keys = Object.keys(obj as T & object);
        const res = {
          ...obj,
        } as T & object;
        keys.forEach((key) => {
          const value = keys[key];
          if (key === 'type') {
            res[key] = value;
          } else if (!isObject(value)) {
            res[key] = value;
          } else {
            res[key] = '...';
          }
        });
        return res;
      };
    }
    return obj;
  }

  // To be used by the machine context
  // Can probably just delete this
  // export function stringifyToWarning<T extends Record<string, any>>(obj: T): T {
  //   if (process.env.NODE_ENV === 'development' && typeof obj === 'object') {
  //     ;(obj as any)['toJSON'] = function () {
  //       return 'Context too large for inspector'
  //     }
  //   }
  //   return obj
  // }

  export function createEventPayload<T>(v: T) {
    return {
      value: shortStringify(v),
    };
  }
}
